import React from 'react';

import { Dropdown, Option } from '@ontruck/ontruck-react-components/lib/Dropdown';
import {
  featurePreferenceToggle,
  ALLOW_VALIDATE_PAYMENT_METHOD,
} from 'modules/preferences-manager/preferences';

const PaymentMethodValidation = ({ value, handleChange, t }) => {
  const paymentMethodValidationEnabled = featurePreferenceToggle(ALLOW_VALIDATE_PAYMENT_METHOD);
  return paymentMethodValidationEnabled ? (
    <Dropdown light="true" openToTop={true} value={value} onChange={handleChange}>
      <Option value="PENDING_VALIDATION">
        {t.labels.payment_method_validation_status['PENDING_VALIDATION']}
      </Option>
      <Option value="VALIDATED">{t.labels.payment_method_validation_status['VALIDATED']}</Option>
      <Option value="DENIED">{t.labels.payment_method_validation_status['DENIED']}</Option>
    </Dropdown>
  ) : null;
};

export default PaymentMethodValidation;
